import UserModel from '../../../../UserModel';
import { CYCLE_DETAILS_ROUTE, CYCLE_WAVE_DETAILS_ROUTE } from '../../../modules/cycleCount/consts';
import { WAREHOUSES_DETAILS_PATH } from '../../../modules/warehouses/consts';
const hasAnyPermissions = (permissions) => UserModel.getCurrentUser().hasAnyPermissions(permissions);

export default {
    name: 'historicalCycleCountPage',
    before: [],
    after: ['cycleCount'],
    setup: (app) => {
        const routeName = 'cycleCountHistoricalGrid';
        const route = app.routes.getItem(routeName);

        if (route) {
            const routeProps = route.props;
            route.props = (state) => ({
                ...routeProps(state),
                permissions: {
                    withExport: true,
                    canAdd: hasAnyPermissions('cycle-counts.create'),
                    canStartCCByLocation: hasAnyPermissions('cycle-counts.create'),
                    // canCancel: hasAnyPermissions('cycle-counts.create'),
                    canShow: hasAnyPermissions('cycle-counts.details'),
                    // withCCDetailsLink: hasAnyPermissions('cycle-counts.details'),
                    withCCWaveDetailsLink: hasAnyPermissions('cycle-counts.details'),
                    // withWarehouseDetailsLink: hasAnyPermissions('warehouses.show'),
                },
                routes: {
                    detailsViewPageRoute: CYCLE_DETAILS_ROUTE,
                    waveDetailsViewPageRoute: CYCLE_WAVE_DETAILS_ROUTE,
                    warehouseDetailsViewPageRoute: WAREHOUSES_DETAILS_PATH,
                },
            });

            route.loader = () => import('./packages/HistoricalCycleCount/core');
            app.routes.changeItem(routeName, route);
        }
    },
};
